import { render, staticRenderFns } from "./TerritoryMap.vue?vue&type=template&id=24ff45d6&scoped=true"
import script from "./TerritoryMap.vue?vue&type=script&lang=js"
export * from "./TerritoryMap.vue?vue&type=script&lang=js"
import style0 from "./TerritoryMap.vue?vue&type=style&index=0&id=24ff45d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff45d6",
  null
  
)

export default component.exports